// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Nth0","title":"styles_title__1plmN"};